import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

const buildListingFormData = (payload, files = []) => {
  const formData = new FormData();
  formData.append(
    "listing",
    new Blob([JSON.stringify(payload)], { type: "application/json" })
  );
  files.forEach((file) => {
    formData.append("files", file);
  });
  return formData;
};

export const getNewestListings = () =>
  wrapServiceCall(() => fetchApi("/listings/newest?page=1&sort=date_from%2Cdesc", { method: "GET" }));

export const getListingById = (listingId) =>
  wrapServiceCall(() => fetchApi(`/listings/${listingId}`, { method: "GET" }));

export const getPromotedListings = ({ page = 1, size = 12 } = {}) =>
  wrapServiceCall(() =>
    fetchApi(`/listings/promoted?page=${page}&size=${size}`, { method: "GET" })
  );

export const searchListings = (
 searchParamString
= {}) =>
  wrapServiceCall(() => {
    const url = `/listings/search?${searchParamString}`;
    return fetchApi(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(),
    });
  });

export const getUserListings = ({ page = 1 } = {}) =>
  wrapServiceCall(() =>
    fetchApi(`/users/listing?page=${page}`, {
      method: "GET",
    })
  );

export const createListing = (payload, files = []) =>
  wrapServiceCall(() =>
    fetchApi("/users/listing", {
      method: "POST",
      body: buildListingFormData(payload, files),
    })
  );

export const updateListing = (listingId, payload, files = []) =>
  wrapServiceCall(() =>
    fetchApi(`/users/listing/${listingId}`, {
      method: "PUT",
      body: buildListingFormData(payload, files),
    })
  );

export const updateListingStatus = (listingId, statusId) =>
  wrapServiceCall(() =>
    fetchApi(`/users/listings/${listingId}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ statusId }),
    })
  );

export const refreshListing = (listingId) =>
  wrapServiceCall(() =>
    fetchApi(`/users/listings/${listingId}/refresh`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    })
  );

export const trackListingView = (payload) =>
  wrapServiceCall(() =>
    fetchApi("/listings/view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
  );

export const autocompleteListings = (query, options = {}) =>
  wrapServiceCall(() =>
    fetchApi(`/listings/autocomplete?q=${encodeURIComponent(query.trim())}`, {
      method: "GET",
      ...options,
    })
  );

export const getRecommendations = ({ type = "personalized", listingId = null, limit = 10, contextQuery = "" } = {}) =>
  wrapServiceCall(() => {
    if (type === "similar" && listingId) {
      const suffix = contextQuery ? `&${contextQuery}` : "";
      return fetchApi(`/recommendations/similar/${listingId}?limit=${limit}${suffix}`, { method: "GET" });
    }
    if (type === "trending") {
      return fetchApi(`/recommendations/trending?page=1&sort=date_from%2Cdesc&limit=${limit}`, { method: "GET" });
    }
    return fetchApi(`/recommendations?limit=${limit}`, { method: "GET" });
  });
